/* eslint-disable max-len */
import Raven from 'raven-js';
import {
  sentryClientDsn,
  sentryConfig,
} from 'src/common/constants/analytics/sentry';
import shouldLogToSentry from '../../common/utils/shouldLogToSentry';

if (shouldLogToSentry()) {
  const options = {
    ...sentryConfig,
    whitelistUrls: [/tunein\.com/],
    ignoreErrors: [
      "Failed to execute 'insertBefore' on 'Node': The node before which the new node is to be inserted is not a child of this node.",
    ],
  };

  Raven.config(sentryClientDsn, options).install();
}
